var exports = {
  "_A": "xaee3c4fa--996863--tags",
  "dp": "xaee3c4fa--996863--tags_schema_org",
  "gU": "xaee3c4fa--996863--tags__link",
};

module.exports = exports;
